import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { startOfToday } from 'date-fns';

import OTTSearchHistory from '@ott/search-history';

import { FIELDS } from '../../constants';
import useSearchHistory from '../../hooks/useSearchHistory';
import * as km from '../../statistic/events';
import { SearchForm } from '../../types';

// Тип айтема истории в общем компоненте @ott/search-history
type SearchHistoryItem = {
  fromDate: SearchForm['date'];
  from: SearchForm['departure'];
  to: SearchForm['destination'];
  adults: SearchForm['adults'];
  childrenAges: SearchForm['childrenAges'];
  departureOption: SearchForm['departureOption'];
  destinationOption: SearchForm['destinationOption'];
};

type Props = {
  abortInitialDepartureSettingIfNeeded: () => void;
  abortInitialDestinationSettingIfNeeded: () => void;
  onClick: () => void;
};

const SearchHistory = ({
  abortInitialDepartureSettingIfNeeded,
  abortInitialDestinationSettingIfNeeded,
  onClick,
}: Props) => {
  const { searchHistory } = useSearchHistory();
  const { setValue } = useFormContext<SearchForm>();

  useEffect(() => {
    if (searchHistory.length) {
      km.trackHistoryLabelsShow({ labelsCount: searchHistory.length });
    }
  }, [searchHistory.length]);

  if (!searchHistory.length) {
    return null;
  }

  const historyItems: SearchHistoryItem[] = searchHistory.map((item) => {
    const {
      date,
      departure,
      departureOption,
      destination,
      destinationOption,
      adults,
      childrenAges,
    } = item;

    return {
      fromDate: new Date(date),
      from: departure,
      to: destination,
      adults,
      childrenAges,
      departureOption,
      destinationOption,
    };
  });

  const handleItemClick = (item: SearchHistoryItem) => {
    const {
      fromDate: date,
      from: departure,
      to: destination,
      departureOption,
      destinationOption,
    } = item;

    abortInitialDepartureSettingIfNeeded();
    abortInitialDestinationSettingIfNeeded();

    const currentDate = startOfToday();
    const historyDate = new Date(date);

    setValue(FIELDS.DEPARTURE, departure);
    setValue(FIELDS.DEPARTURE_OPTION, departureOption);
    setValue(FIELDS.DESTINATION, destination);
    setValue(FIELDS.DESTINATION_OPTION, destinationOption);
    setValue(FIELDS.DATE, historyDate < currentDate ? currentDate : historyDate);

    onClick();
  };

  return <OTTSearchHistory items={historyItems} handleSearch={handleItemClick} project="bus" />;
};

export default React.memo(SearchHistory);
